import React from 'react';
interface PageHeaderProps {
  eyebrow?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  description,
  actions
}: PageHeaderProps) {
  return <header className="flex flex-col gap-5 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-1033" data-mp="ex857oor21yj">
      <div className="min-w-0" data-id="element-1034" data-mp="j0e8qokh9f1b">
        {eyebrow && <div className="mb-2 text-[13px] text-muted" data-id="element-1035" data-mp="3idyjsryednbu">{eyebrow}</div>}
        <h1 className="font-display text-[28px] font-light leading-tight text-ink sm:text-[34px]" data-id="element-1036" data-mp="3ifrm5v1z9le1">{title}</h1>
        {description && <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-body" data-id="element-1037" data-mp="3rdlih5zqsf17">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap gap-3" data-id="element-1038" data-mp="8v6ijya250c">{actions}</div>}
    </header>;
}